import axios from 'axios'
import { notify } from 'notiwind'
import router from '@/router'
import { useAuthStore } from '@/stores/auth'
import Loading from '@/components/Ui/Loading/index.js'
import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'

const baseConfig = {
  baseURL: '/echannels/api'
}

const axiosInstance = axios.create(baseConfig)

// useMockData(axiosInstance)

const baseRequestInterceptor = (config) => {
  const globalStorage = JSON.parse(localStorage.global || '{}')
  const authStorage = JSON.parse(localStorage.auth || '{}')

  config.headers = {
    'Content-Type': 'application/json;charset=utf-8',
    languageId: globalStorage?.languageId || 2,
    ...config.headers
  }

  if (Object.keys(authStorage?.user || {}).length > 0) {
    const { userToken, refreshToken } = authStorage.user
    Object.assign(config.headers, {
      userToken,
      refreshToken
    })
  }

  const inConfig = Object.keys(config).includes('preventLoadingAnimation')
  if (!inConfig || !config.preventLoadingAnimation) {
    Loading.loading.show()
  }
  return config
}

axiosInstance.interceptors.request.use(baseRequestInterceptor)

axiosInstance.interceptors.response.use(
  ({ /**config, status, statusText, */ data }) => {
    // parse general data here
    Loading.loading.hide()
    return data
  },
  // error handler
  (data) => {
    Loading.loading.hide()
    if ([401, 403].includes(data?.response?.status)) {
      useAuthStore().logout()
      useFormStore().$reset()
      useGlobalStore().$reset()
      return router.replace('/')
    }

    notify(
      {
        group: 'error',
        title: data?.response?.data[0]?.message || data.response?.statusText || 'error!',
        text: data?.response?.data?.message
      },
      6000
    )
    throw 'error!'
  }
)

/**
 * for requests that need to bubble up the error
 * example: /api/NominationGoldenVisa/draft/getPersonalDetails
 * in checkPersonalInfoByIdentity
 */
const axiosNoResponseInterceptor = axios.create(baseConfig)
axiosNoResponseInterceptor.interceptors.request.use(baseRequestInterceptor)
axiosNoResponseInterceptor.interceptors.response.use(
  ({ data }) => {
    Loading.loading.hide()
    return data
  },
  (data) => {
    Loading.loading.hide()
    throw data
  }
)

export { axiosNoResponseInterceptor }

export default axiosInstance
